import { useContext } from 'react'

import { SplitTestsContext } from '@Globals/SplitTests/Context'
import { Group, Test } from '@Globals/SplitTests/types'

export function useSplitTest(test: Test): Group
export function useSplitTest(test: Test, group: Group): boolean
export function useSplitTest(test: Test, group?: Group) {
  const { activateSplitTest, observeSplitTest, splitTests } = useContext(SplitTestsContext)
  const splitTest = splitTests[test]

  observeSplitTest(test)

  if (!splitTest) {
    if (group) {
      return group === 'a'
    }

    return 'a'
  }

  const splitTestGroup = splitTest?.group || 'a'
  activateSplitTest(test, splitTestGroup)

  if (!group) {
    return splitTestGroup
  }

  return splitTestGroup === group
}
